define('plugin/additional-fields/model/AdditionalFieldModel',['require','lib/model/BaseModel','lib/validator/ValidatorNotEmpty','lib/validator/ValidatorDigitsOnly'],function (require) {

    var BaseModel = require('lib/model/BaseModel');
    var ValidatorNotEmpty = require('lib/validator/ValidatorNotEmpty');
    var ValidatorDigitsOnly = require('lib/validator/ValidatorDigitsOnly');

    /**
     * Additional field model
     *
     * @class AdditionalFieldModel
     */
    return BaseModel.extend({
        
        parent_id_field: 'sheduler_id',
        
        cloudFileUploadUrl: '/ext/cloud-storage/upload',

        defaults: {
            id: '',
            name: '',
            title: '',
            type: '',
            values: [],
            default: null,
            is_null: false,
            value: null,
            error: false
        },

        initialize: function () {
            this.initValidators();

            this.updatePredefinedFieldInfo();

            this.listenTo(Config.getInstance(), 'config:changed', this.updatePredefinedFieldInfo);            

            BaseModel.prototype.initialize.call(this);
        },
        
        getDefault: function () {
            var predefined = Config.getInstance().getOption('predefined') || {};
            var name = this.get('name');
            if (predefined.fields && predefined.fields[name]) {
                return predefined.fields[name];
            }
            return this.get('default');
        },
        
        initValidators: function () {
            var validators = [];
            
            // if (this.get('type') === 'static') { //DEBUG
            //     return;
            // }
            
            if (!parseInt(this.get('is_null'))) {
                validators.push(new ValidatorNotEmpty());
            }
            if (this.get('type') === 'digits') {
                validators.push(new ValidatorDigitsOnly());
            }

            this.validators = {
                value: validators
            };
        },

        updatePredefinedFieldInfo: function () {
            //console.log('updatePredefinedFieldInfo');
            var predefined = Config.getInstance().getOption('predefined') || {};
            var name = this.get('name');
            if (predefined.fields && predefined.fields[name]) {
               // console.log('set default value', predefined.fields[name]);
                this.set('default', predefined.fields[name]);
            }
        },

        parse: function () {
            var data = BaseModel.prototype.parse.apply(this, arguments);
            if (data.type === 'checkbox' && data.default == '0') {
                data.default = '';
            }

            return data;
        },

        validate: function () {
            var result = BaseModel.prototype.validate.apply(this, arguments);
            var error = null;

            if (result && result.value) {
                error = result.value.shift();
            }

            this.set('error', error);

            return result;
        },
        
        uploadFile: function (file, parentId) {
            var _this = this;
            
            return new Promise(function (resolve, reject) {
                
                var form_data = new FormData();
                form_data.append('file', file);
                if (parentId) form_data.append(_this.parent_id_field, parentId);
                
                Backbone.ajax({
                    url: _this.baseUrl + _this.cloudFileUploadUrl,
                    dataType: 'json',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: form_data,
                    type: 'post',
                }).success(function (data) {
                    if (data.success) {
                        resolve(data.hash);
                    } else {
                        reject(data.errors);
                    }
                }).error(function (error) {
                    reject(error);
                });
                
            });
        }

    });

});
